import React, { useState } from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import { Form, Input, Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
// eslint-disable-next-line import/no-extraneous-dependencies
import { AuthWrapper } from '../style';
import { signIn } from '../../../../../redux/authentication/actionCreator';
import { Checkbox } from '../../../../../components/checkbox/checkbox';
import Heading from '../../../../../components/heading/heading';

const SignIn = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const isLoading = useSelector(state => state.auth.loading);
  const [form] = Form.useForm();
  const [state, setState] = useState({
    checked: null,
  });

  const handleSubmit = values => {
    values.phone = `60${values.phone}`;
    let param = {
      customerType: 'RECRUITER',
      msisdn: values.phone,
      password: values.password,
    };
    dispatch(signIn(param));
  };

  const onChange = checked => {
    setState({ ...state, checked });
  };

  return (
    <AuthWrapper>
      <div style={{ backgroundColor: '#EA0029', borderRadius: '14px' }} className="auth-contents">
        <Form name="login" form={form} onFinish={handleSubmit} layout="vertical">
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '2vh' }}>
            <h4 style={{ fontWeight: 'bold', color: 'white' }}>Log masuk ke &nbsp;</h4>
          </div>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            {' '}
            <img style={{ width: '108px', height: '54px' }} className="logo" src="images/nav-logo.png"></img>
          </div>
          <br /> <br />
          <Form.Item
            name="phone"
            rules={[
              { message: <span style={{ color: 'white' }}>*Sila masukkan nombor telefon anda!</span>, required: true },
              {
                pattern: /^[0-9]{9,11}$/,
                message: <span style={{ color: 'white' }}>Sila isikan nombor telefon yang sah</span>,
              },
            ]}
            label={<span style={{ color: 'white' }}>Nombor Telefon Bimbit</span>}
          >
            <Input type="number" addonBefore={'+60'} placeholder="1023456489" />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[{ message: 'Kata Laluan', required: true }]}
            label={<span style={{ color: 'white' }}>Kata Laluan</span>}
          >
            <Input.Password placeholder="Kata Laluan" />
          </Form.Item>
          <div className="auth-form-action">
            <Checkbox onChange={onChange}>
              <span style={{ color: 'white' }}>Sentiasa log masuk</span>
            </Checkbox>
            <NavLink className="forgot-pass-link" to="/reset-password">
              <span style={{ color: 'white' }}> Lupa Kata Laluan?</span>
            </NavLink>
          </div>
          <Form.Item>
            <div className="auth-form-action-button-container">
              <Button className="auth-form-action-button" htmlType="submit" type="primary" size="large">
                {isLoading ? 'Loading...' : 'LOG MASUK'}
              </Button>
            </div>
          </Form.Item>
          <div>
            <p className="form-signup-link">
              <NavLink to="/signup">
                <span style={{ color: 'white', textDecoration: 'underline' }}> Tiada Akaun ? Daftar sini</span>
              </NavLink>
            </p>
          </div>
        </Form>
      </div>
    </AuthWrapper>
  );
};

export default SignIn;
